import CuratenieGaleriiComerciale from "pages/Servicii/ServiciiSpeciale/CuratenieGaleriiComerciale";

export default function CuratenieGaleriiComercialePage() {
    return <CuratenieGaleriiComerciale />;
}
